import { useState } from "react";
import CustomButton from "../CustomButton";
import CustomInput from "../CustomInput";
import ModalLayout from "../layouts/ModalLayout";

interface Props {
  onClose?: () => void;
  onSave?: (field: { name: string; description: string }) => void;
}

export default function MedicalFields({ onClose, onSave }: Props) {
  const [fieldName, setFieldName] = useState("");
  const [fieldDescription, setFieldDescription] = useState("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (fieldName.trim()) {
      onSave?.({
        name: fieldName.trim(),
        description: fieldDescription.trim(),
      });
      onClose?.();
    }
  };

  return (
    <ModalLayout onClose={onClose}>
      <form
        className="flex flex-col gap-8 max-w-xl"
        onSubmit={handleSubmit}
      >
        <CustomInput
          name="name"
          label="Field name"
          type="text"
          placeholder="Eg. Rections"
          value={fieldName}
          onChange={(e) => setFieldName(e.target.value)}
          inputClassName="w-full"
        />
        <CustomInput
          name="name"
          label="Field description"
          type="text"
          placeholder="Eg. Reaction with balms and creams"
          value={fieldDescription}
          onChange={(e) => setFieldDescription(e.target.value)}
          inputClassName="w-full"
        />
        <div className="flex justify-end items-end gap-5">
          <CustomButton
            color="bg-neutral-200"
            text="Cancel"
            onClick={onClose}
          />
          <CustomButton color="bg-primary-500" text="Save Class" type="submit" />
        </div>
      </form>
    </ModalLayout>
  );
}
